module.exports = __webpack_public_path__ + "img/platform4.a7622535.png";